import { render, staticRenderFns } from "./certificateDetailView.vue?vue&type=template&id=459df328&"
import script from "./certificateDetailView.vue?vue&type=script&lang=js&"
export * from "./certificateDetailView.vue?vue&type=script&lang=js&"
import style0 from "./certificateDetailView.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports